import {
  DEFAULT_TRACK_GAIN_DB,
  type TracksStore,
  TrackType,
} from '@/shared/store/tracks.store.tsx'
import type {
  AudioFormClip,
  AudioFormLayer,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import type { Clip } from '../../models/clip.ts'
import { trackVolumeToGain } from './track-volume-to-gain.ts'

export const mapVoicesAndSpeechesToAudioformLayers = (
  trackStore: TracksStore
): AudioFormLayer[] => {
  const voicesTrack = trackStore.tracks.find(
    (track) => track.type === TrackType.Voices
  )
  const gain = trackVolumeToGain(voicesTrack?.volume ?? DEFAULT_TRACK_GAIN_DB)
  const speeches = voicesTrack?.clips ?? []

  const clips = speeches
    .filter(
      (clip): clip is Clip & { startAt: number } => clip.startAt !== undefined
    )
    .sort((a, b) => a.startAt + a.startOffset - (b.startAt + b.startOffset))

  let previousEnding = 0

  const voiceClips: AudioFormClip[] = clips.flatMap((clip) => {
    const marginStart = clip.startAt + clip.startOffset - previousEnding
    previousEnding = clip.startAt + clip.duration + clip.endOffset

    return [
      {
        assetRef: clip.mediaId,
        ...(clip.fadeIn > 0 && { fadeIn: clip.fadeIn }),
        ...(clip.fadeOut > 0 && { fadeOut: clip.fadeOut }),
        ...(clip.startOffset > 0 && { readPosition: clip.startOffset }),
        forcedDuration: clip.duration - clip.startOffset + clip.endOffset,
        marginStart: Math.max(marginStart, 0), // to avoid infinitesimal negative values
        gain,
      },
    ]
  })

  return [{ clips: voiceClips }]
}
